import React, { lazy, useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import Footer from "../components/common/footer";
import { useAtom } from "jotai";
import AdIframeTs from "@Components/ad/adIframeTs";
import WebsiteNav from "@Components/websiteNav";
import AdGlobalPopad from "@Components/ad/AdGlobalPopad";
import { activityAtom } from "@Lib/jotai/activity";
import AppDownload from "@Components/common/AppDownload";
import { clarity } from "react-microsoft-clarity";
import { loginAtom } from "@Lib/jotai/login";
import { delayFetch } from "@Lib/delayFetch";
import { useDebounceEffect } from "ahooks";
import { initClarity } from "@t8891/third-parties";
import InitComponent from "../pages/init";
import "@Styles/global.less";
import "@Styles/base.css";
import AdIframeImage from "@Components/ad/AdFrame_v2";
import { pkListAtom } from "@Lib/jotai/pkCompare";
import useInViewportLoad from "utils/useInViewportLoad";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

interface IProps {
  params: {
    AdTopBanner?: boolean;
    nav?: "" | "SlimNav" | "DefaultFixedNav";
    footer?: "" | "Footer";
    needRTBH?: boolean;
    webPageNav?: boolean;
    appDownload?: boolean;
  };
}
const BaseLayout: React.FC<IProps> = ({ children, params }) => {
  const {
    AdTopBanner = true,
    nav = "",
    footer = "Footer",
    needRTBH = false,
    webPageNav = true,
    appDownload = true,
  } = params;
  const [, updateActivityInfo] = useAtom(activityAtom);
  const [loginInfo, updateLoginInfo] = useAtom(loginAtom);
  const [isLoaded, setIsLoaded] = useState(false);
  const [globalPkList, updateGlobalPkList] = useAtom(pkListAtom);
  const [footerRef, hasBeenInViewFooter] = useInViewportLoad({
    rootMargin: "50px",
  });

  const storedData = localStorage.getItem("globalPkComparison");
  const initialData = storedData !== "null" && storedData ? JSON.parse(storedData) : [];

  const updateStatus = () => {
    // 获取活动接口
    updateActivityInfo({ name: "inquiry-sale" }); //更新登录状态
    updateLoginInfo();

    // 全局pk数据
    if (globalPkList.length === 0 && initialData.length > 0) {
      updateGlobalPkList(initialData);
    }
  };

  const initRtbh = () => {
    if (needRTBH) {
      setTimeout(() => {
        (function (w, d, dn, t) {
          w[dn] = w[dn] || [];
          w[dn].push({ eventType: "init", value: t, dc: "asia" });
          var f = d.getElementsByTagName("script")[0],
            c = d.createElement("script");
          c.async = true;
          c.src = "https://tags.creativecdn.com/tXb3jYXmh7pe5qFj06V7.js";
          f?.parentNode?.insertBefore(c, f);
        })(window, document, "rtbhEvents", "tXb3jYXmh7pe5qFj06V7");
      }, 4000);
    }
  };

  const handleAfterLoad = () => {
    setIsLoaded(true);
  };

  useEffect(() => {
    delayFetch(() => {
      updateStatus();
    });

    // 录屏监控
    clarity.init("migw9xduwf");

    initRtbh();

    window.addEventListener("load", handleAfterLoad);

    return () => {
      window.removeEventListener("load", handleAfterLoad);
    };
  }, []);

  useDebounceEffect(
    () => {
      // ----------------- 微软录屏追踪 -----------------
      initClarity("migw9xduwf", "G-4YCT4M05RT", loginInfo?.data?.m_id || "");
      // ----------------- 微软录屏追踪 end -----------------
    },
    [loginInfo],
    { wait: 500 },
  );

  return (
    <QueryClientProvider client={queryClient}>
      <InitComponent />
      {webPageNav && (
        <WebsiteNav>
          {nav === "DefaultFixedNav" && AdTopBanner && (
            <div
              style={{
                width: "1190px",
                height: "120px",
                margin: "0 auto",
                position: "relative",
                background: "#9e9e9e",
              }}
            >
              <AdIframeImage
                slot={"/173427088/newcar-pc-homepage-topbanner"}
                size={[["fluid"], [1190, 120]]}
                width={1190}
                height={120}
                styles={{ width: "1190px", height: "120px", margin: "0 auto", position: "relative" }}
              />
            </div>
          )}
        </WebsiteNav>
      )}
      <section>{children}</section>
      {!!footer && <div ref={footerRef}>{hasBeenInViewFooter && isLoaded && <Footer />}</div>}

      {appDownload && isLoaded && <AppDownload />}

      <AdGlobalPopad blacklist={["/campaigns/:any*", "/iframeSignIn"]} />
    </QueryClientProvider>
  );
};

export default BaseLayout;
